import React from 'react';
import './ServiceDialog.css';

function ServiceDialog({ service, isOpen, onClose }) {
  if (!isOpen || !service) return null;

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <button className="dialog-close" onClick={onClose}>×</button>
        
        <div className="dialog-header">
          <img className="dialog-icon" alt="icon" src={service.icon}></img>
          <h2>{service.title}</h2>
        </div>

        <div className="dialog-body">


          <div className="dialog-description">
            {service.description?.split('\n\n')?.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>


          {service.keyServices ? (<div className="dialog-key-services">
            <h3>Key Services:</h3>
            <ul className="dialog-services-list">
              {service.keyServices?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>) : (<></>)}
          

          {

            service.subServices?.map(subService=>{
              return (
                  <div className="subservice">
                    <div className="subservice-header">
          <img className="dialog-icon" alt="icon" src={subService.icon}></img>
          <h2>{subService.title}</h2>
        </div>
                   
                  <div className="dialog-description">
                  {subService.description.split('\n\n').map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
      
                <div className="dialog-key-services">
                  <h3>Key Services:</h3>
                  <ul className="dialog-services-list">
                    {subService.keyServices.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div></div>

              )

            })

          }



        </div>
      </div>
    </div>
  );
}

export default ServiceDialog;

